const TwilioComponentStyle = theme => ({
    twilioWrapper: {
        position: "absolute",
        display: "flex",
        top: 0,
        right: 0,
        backgroundColor: "transparent",
        borderRadius: "15px",
    },
    twilioWrapperV2: {
        position: 'relative',
        display: 'flex',
        backgroundColor: 'transparent',
        borderRadius: '16px',
    },
    twilioVideoWrapper: {
        position: "relative",
        display: "flex",
        transition: "all .3s ease",
    },
    selfView: {
        width: 210,
        position: "absolute",
        transform: "translate3d(0, 0, 0)",
        left: 0,
        overflow: "hidden",
        height: "180px",
        borderRadius: "15px",
        border: "1px solid #979797",
        borderRightWidth: 0,
        backgroundColor: "#CCCCCC"
    },
    actionsWrapper: {
        borderRadius: "15px",
        transform: "translate3d(0, 0, 0)",
        overflow: "hidden",
        position: "absolute",
        right: 0,
        border: "1px solid #979797",
        transition: "all .3s ease",
        backgroundColor: "white",
    },

    chatWrapper: {
        position: "absolute",
        bottom: 0,
        display: "flex",
    },
    settingContentWrapper: {
        display: "flex",
        width: "100%",
        padding: "0px 25px 10px 25px",
        flexDirection: "column"
    },
    settingText: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    productInput: {
        width: "100%",
        height: 30,
        "& > div": {
            height: 30,
            border: "1px solid #979797",
            borderRadius: 3
        },
        "& fieldset": {
            display: "none"
        },
        "& div": {
            color: "#242424",
            fontFamily: "Proxima Nova",
            fontSize: "14px",
            letterSpacing: 0,
            backgroundColor: "white",
            lineHeight: "17px"
        },
        "& div:focus": {
            backgroundColor: "white !important",
        }
    },
    productSelectStyle: {
        padding: 0,
        paddingLeft: 10
    },
    menuItemWidth: {
        minWidth: "auto",
        maxWidth: "188px"
    },
    menuItemList: {
        "& li": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "inline-block",
            width: "100%"
        }
    },
    menuItemSelected: {
        backgroundColor: "#f3fdfd !important"
    },
    menuItemRoot: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    chatHistoryWrapper: {
        display: "flex",
        flex: 1,
        padding: "0px 10px 0px 10px",
        flexDirection: "column-reverse",
    },
    textInputWrapper: {
        height: 39,
        width: "100%",
        display: "flex",
        padding: "0px 5px 0px 5px",
        backgroundColor: "#F5F5F5",
        alignItems: "center"
    },
    inputText: {
        height: 29,
        minHeight: 29,
        maxHeight: 29,
        flex: 1,
        borderRadius: 10,
        backgroundColor: "#FFFFFF",
        border: 0,
        outline: "none",
        padding: "7px 5px 0px 10px",
        "font-family": "Proxima Nova",
        "font-size": "14px",
        "letter-spacing": 0,
        "line-height": "17px",
        marginRight: 3,
        resize: "none",
        boxSizing: "border-box",
    },
    sendIcon: {
        height: 17,
        minHeight: 17,
        maxHeight: 17,
        minWidth: 17,
        maxWidth: 17,
        width: 17,
        cursor: "pointer"
    },
    userChatBubble: {
        display: "flex",
        marginBottom: 10,
        width: "87%",
        minWidth: "87%",
        maxWidth: "87%",
        alignSelf: "flex-end",
        flexShrink: 0,
        wordBreak: "break-word",
        whiteSpace: "pre-wrap",
        justifyContent: "flex-end"
    },
    userChatBubbleText: {
        borderRadius: 10,
        backgroundColor: "#00AD50",
        color: "#FFFFFF",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        display: "inline-block",
        letterSpacing: 0,
        lineHeight: "17px",
        padding: "5px 10px",
        wordBreak: "break-word",
        whiteSpace: "pre-wrap"
    },
    participantChatBubble: {
        display: "flex",
        marginBottom: 10,
        width: "87%",
        minWidth: "87%",
        maxWidth: "87%",
        flexShrink: 0,
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
    },
    participantChatBubbleText: {
        borderRadius: 10,
        backgroundColor: "#F5F5F5",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        display: "inline-block",
        letterSpacing: 0,
        lineHeight: "17px",
        padding: "5px 10px",
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
    },
    paitentView: {
        transform: "translate3d(0, 0, 0)",
        overflow: "hidden",
        position: "absolute",
        right: 0,
        backgroundColor: "#CCCCCC",
        border: "1px solid #979797",
        borderRadius: "15px",
        transition: "all .3s ease",
    },
    expandIconStyle: {
        width: "27px !important",
        margin: 0,
        position: "absolute",
        top: 5,
        left: 5,
        padding: "0px !important",
        height: 27,
        backgroundColor: "white",
        borderRadius: "100%",
        verticalAlign: "unset",
        boxShadow: "0 0 6px 0 #000000",
        "& span": {
            maxHeight: 15,
            maxWidth: 15,
            minHeight: 15,
            minWidth: 15
        }
    },
    expanIcon: {
        height: 15,
        width: 15,
        maxHeight: 15,
        maxWidth: 15,
        minHeight: 15,
        minWidth: 15,
    },
    expandChatIconStyle: {
        width: "27px !important",
        margin: 0,
        position: "absolute",
        top: 37,
        left: 5,
        padding: "0px !important",
        height: 27,
        backgroundColor: "white",
        borderRadius: "100%",
        verticalAlign: "unset",
        boxShadow: "0 0 6px 0 #000000",
        "& span": {
            maxHeight: 15,
            maxWidth: 15,
            minHeight: 15,
            minWidth: 15
        }
    },
    dropCallButtonStyle: {
        width: "27px !important",
        margin: 0,
        padding: "0px !important",
        height: 27,
        backgroundColor: "white",
        borderRadius: "100%",
        verticalAlign: "unset",
        boxShadow: "0 0 6px 0 #000000",
        "& span": {
            maxHeight: 15,
            maxWidth: 15,
            minHeight: 15,
            minWidth: 15
        }
    },
    dropCallIcon: {
        height: 15,
        width: 15,
        maxHeight: 15,
        maxWidth: 15,
        minHeight: 15,
        minWidth: 15
    },
    videoButtonStyle: {
        width: "27px !important",
        margin: 0,
        padding: "0px !important",
        height: 27,
        marginRight: 5,
        backgroundColor: "white",
        borderRadius: "100%",
        verticalAlign: "unset",
        boxShadow: "0 0 6px 0 #000000",
        "& span": {
            maxHeight: 15,
            maxWidth: 15,
            minHeight: 15,
            minWidth: 15
        }
    },
    videoIcon: {
        height: 15,
        width: 15,
        maxHeight: 15,
        maxWidth: 15,
        minHeight: 15,
        minWidth: 15
    },
    microPhoneButtonStyle: {
        width: "27px !important",
        margin: 0,
        padding: "0px !important",
        height: 27,
        marginRight: 5,
        backgroundColor: "white",
        borderRadius: "100%",
        verticalAlign: "unset",
        boxShadow: "0 0 6px 0 #000000",
        "& span": {
            maxHeight: 15,
            maxWidth: 15,
            minHeight: 15,
            minWidth: 15
        }
    },
    microphoneIcon: {
        height: 15,
        width: 15,
        maxHeight: 15,
        maxWidth: 15,
        minHeight: 15,
        minWidth: 15
    },
    chatButtonStyle: {
        width: "27px !important",
        margin: 0,
        padding: "0px !important",
        height: 27,
        backgroundColor: "white",
        borderRadius: "100%",
        verticalAlign: "unset",
        boxShadow: "0 0 6px 0 #000000",
        "& span": {
            maxHeight: 15,
            maxWidth: 15,
            minHeight: 15,
            minWidth: 15
        }
    },
    chatIcon: {
        height: 15,
        width: 15,
        maxHeight: 15,
        maxWidth: 15,
        minHeight: 15,
        minWidth: 15
    },
    settingButtonStyle: {
        width: "27px !important",
        margin: 0,
        padding: "0px !important",
        height: 27,
        backgroundColor: "white",
        borderRadius: "100%",
        verticalAlign: "unset",
        boxShadow: "0 0 6px 0 #000000",
        "& span": {
            maxHeight: 15,
            maxWidth: 15,
            minHeight: 15,
            minWidth: 15
        }
    },
    settingIcon: {
        height: 15,
        width: 15,
        maxHeight: 15,
        maxWidth: 15,
        minHeight: 15,
        minWidth: 15
    },
    relativeContainer: {
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex"
    },
    callButtonsWrapper: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 5px 5px 5px"
    },
    callActionButtonsWrapper: {
        display: "flex"
    },
    localMedia: {
        height: "100%",
        width: "100%"
    },
    remoteMedia: {
        height: "100%",
        width: "100%",
        position: "absolute"
    },
    connectingMessage: {
        position: "absolute",
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255,255,255,0.9)",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "24px",
        letterSpacing: 0,
        lineHeight: "29px",
        textAlign: "center",
        border: "1px solid #979797",
        borderRadius: "15px",
    },
    waitingMessage: {
        position: "absolute",
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#CCCCCC",
    },
    waitingMessageWrapper: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        color: "#FFFFFF",
        fontFamily: "Proxima Nova",
    },
    participantWaitngText: {
        fontSize: "18px",
        fontWeight: "300",
        letterSpacing: 0,
        lineHeight: "22px",
        textAlign: "center",
        marginBottom: 20
    },
    participantName: {
        fontSize: "24px",
        letterSpacing: 0,
        lineHeight: "29px",
        textAlign: "center",
        wordBreak: "break-word",
        marginBottom: "28px"
    },
    placeHolderIconWrapper: {
        position: "absolute",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#d8d8d8"
    },
    placeHolderAudioWrapper: {
        display: "flex",
        position: "relative",
        alignItems: "center",
        marginRight: 5,
        justifyContent: "flex-end",
    },
    placeHolderIcon: {
        height: 80,
        width: 80,
        maxHeight: 80,
        minHeight: 80,
        maxWidth: 80,
        minWidth: 80,
        position: "relative",
    },
    videoOffIconWrapper: {
        height: 54,
        width: 72,
        position: "absolute",
        backgroundColor: "rgba(255,255,255,0.8)",
        zIndex: 9
    },
    videoOffIcon: {
        margin: "12px 19px"
    },
    participantIcon: {
        height: 160,
        width: 160,
        maxHeight: 160,
        minHeight: 160,
        maxWidth: 160,
        minWidth: 160,
        position: "relative",
    },
    endCallWrapper: {
        backgroundColor: "rgba(255,255,255,0.9)",
        position: "absolute",
        width: "100%",
        flexDirection: "column",
        height: "100%",
        display: "flex",
        zIndex: 10
    },
    endCallActionWrapper: {
        display: "flex",
        width: "100%",
        justifyContent: "space-around",
        padding: "0px 15px 15px 15px"
    },
    buttonStyle: {
        boxShadow: 'none',
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: '0 4px',
        fontWeight: "bold",
        backgroundColor: '#00ad50',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:disabled': {
            color: 'white',
            boxShadow: 'none',
        },
    },
    cancelButtonStyle: {
        boxShadow: 'none',
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: '0 4px',
        border: "1px solid #4d4d4d",
        color: "#242424",
        fontWeight: "bold",
        backgroundColor: 'white',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
    },
    endCallText: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px",
        textAlign: "center",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        padding: "0px 21px 0px 21px"
    },
    selectDisabled: {
        "& div": {
            backgroundColor: "#e4e4e4 !important"
        }
    },
    participantIconNameWrapperCollapse: {
        height: 26,
        width: "100%",
        position: "absolute",
        textAlign: "center",
        lineHeight: "12px",
        top: "74px"

    },
    participantIconNameCollapse: {
        fontSize: "14px",
        fontWeight: "bold",
        letterSpacing: 0,
        textAlign: "center",
        wordBreak: "break-all",
    },
    participantIconNameWrapper: {
        height: 26,
        width: "100%",
        position: "absolute",
        lineHeight: "22px",
        textAlign: "center",
        top: "170px"
    },
    participantIconName: {
        fontSize: "18px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "22px",
        textAlign: "center",
        wordBreak: "break-all",
    },
    placeholderInsideWrapper: {
        width: "67%",
        textAlign: "center",
    }
})

export default TwilioComponentStyle;